import styled from 'styled-components';

export const Container = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    overflow: auto;
`;

export const Image = styled.img`
    width: 100%;
    height: 100%;
    
    &.keepAspect {
        object-fit: contain;
    }
`;
